 
<template>
  <div class="newsDetial">
    <div class="newsDetial-header">
      <div class="newsDetial-title">{{ newsDetails.title }}</div>
      <blank height="15"> </blank>
    </div>
    <div class="newsDetial-cont">
      <div class="newsDetial-cont-top">
        <!-- <div class="newsDetial-history">
          首页 >{{ $route.meta.isMenuOpens }}>{{ $route.meta.isMenuOpens }}
        </div> -->
        <div class="newsDetial-name">
          {{ newsDetails.title }}
        </div>
        <div class="newsDetial-set">
          <div class="newsDetial-set-item">
            发布时间：{{ newsDetails.time }}
          </div>
          <div class="newsDetial-set-item">
            信息来源：{{ newsDetails.source }}
          </div>
          <div class="newsDetial-set-item">
            提交人：{{ newsDetails.editperson }}
          </div>
          <div class="newsDetial-set-item">
            浏览次数：{{ newsDetails.circulate }}
          </div>
          <div class="set-font">
            [字体：<span
              @click="fontSizeClick('0')"
              :class="fontSizea == 0 ? 'fontSizea' : ''"
              >大</span
            >
            <span
              :class="fontSizea == 1 ? 'fontSizea' : ''"
              @click="fontSizeClick('1')"
              >中</span
            >
            <span
              :class="fontSizea == 2 ? 'fontSizea' : ''"
              @click="fontSizeClick('2')"
              >小</span
            >
            ]
          </div>
        </div>
      </div>
      <blank height="1"> </blank>
      <div
        class="newsDetial-cont-view"
        :style="{ fontSize: fontSizeb + 'px' }"
        v-html="newsDetails.content"
      ></div>
    </div>
    <appfloor></appfloor>
  </div>
</template>
<script>
import { TheInformationReleaseDetial } from '@/views/InformationPublish/api/api'
export default {
  data() {
    return {
      newsDetails: {},
      fontSizeb: 18,
      fontSizea: 1
    }
  },
  created() {
    TheInformationReleaseDetial({
      id: this.$router.currentRoute.query.id
    }).then((res) => {
      if (res.data.code == 0) {
        this.newsDetails = res.data.data
      }
    })
  },
  methods: {
    fontSizeClick(fontsize) {
      if (fontsize == 0) {
        this.fontSizeb = 24
        this.fontSizea = 0
      } else if (fontsize == 1) {
        this.fontSizeb = 18
        this.fontSizea = 1
      } else if (fontsize == 2) {
        this.fontSizeb = 14
        this.fontSizea = 2
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.newsDetial-header {
  background: #fff;
  padding: 0 40px;
  .newsDetial-title {
    height: 26px;
    color: rgba(56, 56, 56, 1);
    font-size: 18px;
    line-height: 26px;
    font-weight: bold;
  }
  .newsDetial-abstract {
    color: rgba(166, 166, 166, 1);
    font-size: 14px;
    line-height: 22px;
  }
}
.newsDetial-cont {
  margin: 24px 16px;
  .newsDetial-cont-top {
    background: #fff;
    padding: 10px 25px;
    .newsDetial-history {
      height: 22px;
      color: rgba(166, 166, 166, 1);
      font-size: 14px;
      line-height: 22px;
      text-align: left;
    }
    .newsDetial-name {
      padding: 20px 100px;
      color: rgba(0, 0, 0, 1);
      font-size: 22px;
      line-height: 35px;
      text-align: center;
    }
    .newsDetial-set {
      padding: 0px 100px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .newsDetial-set-item {
        height: 22px;
        color: rgba(166, 166, 166, 1);
        font-size: 14px;
        line-height: 22px;
      }
    }
  }
  .newsDetial-cont-view {
    background: #fff;
    padding: 30px 90px;
    color: rgba(56, 56, 56, 1);
    font-size: 14px;
  }
}
.set-font {
  span {
    cursor: pointer;
  }
  .fontSizea {
    color: red;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/workbench/newsDetial.vue